module.exports = __webpack_public_path__ + "account/img/276.e49314df.png";